import { createReducer, on } from '@ngrx/store';
import { GerichtProfileResource } from './gerichtprofile.model';
import { loadGerichtProfileSuccessAction, updateGerichtProfileSuccessAction } from './gerichtprofile.actions';

export interface GerichtProfileState {
	gerichtProfile: GerichtProfileResource;
}

export const initialState: GerichtProfileState = {
	gerichtProfile: undefined,
};

export const gerichtProfileReducer = createReducer(
	initialState,
	on(
		loadGerichtProfileSuccessAction,
		updateGerichtProfileSuccessAction,
		(state: GerichtProfileState, { gerichtProfile }): GerichtProfileState => ({
			...state,
			gerichtProfile,
		})
	)
);
